module.exports = __webpack_public_path__ + "static/media/goldenprize-sardine-brine.657826c3.png";